import { useSessionData } from '../auth/SessionDataHook';
import useCurrentUser from 'src/admin/users/hooks/useCurrentUser';
import { hasAfternoonAccess } from 'src/common/afternoonAccess';

export const useIsAfternoon = () => {
  const { session } = useSessionData();
  const { currentUser } = useCurrentUser();
  const tenantId = session?.identity?.metadata_public?.['tenantId'];

  const isCrawford = currentUser?.id === '89a53825-bb1f-46f1-a598-e28509acdc63';
  const isAfternoon = isCrawford || hasAfternoonAccess(tenantId, currentUser?.emailAddress);

  return {
    isAfternoon,
    isCrawford,
    isAfternoonAdmin: isAfternoon && !!session?.identity?.metadata_public.isAdmin,
  };
};
